import produce from "immer";
import { RouteActions, UPDATE_ROUTE_ITEMS } from "./action";
import { MenuItem } from "../../typings/typings";

export interface RouteState
{
    routeItems: MenuItem[];
}

const initialState: RouteState =
{
    routeItems: []
};

export const reducer = (routeState = initialState, action: RouteActions): RouteState => produce(routeState, draft =>
{

    switch (action.type)
    {
        case UPDATE_ROUTE_ITEMS: {
            draft.routeItems = action.routeItems;
            break;
        }
    }
});

export const getRouteItems = (state: RouteState) => state.routeItems;

export default reducer;